import { useAppStore } from "@/app/store/app/store";
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import {
        INavigationSteps,
        IProcessData,
        IAppNavButton,
        createExposureData,
        createContractData,
        createPreapprovedData,
        createCustomerData,
        createCalculationData,
        createEmploymentData,
        createSisbonData,
        createIdentificationData,
        createProcessData,
        createNavigationSteps,
        IContractData,
        IExposureData,
        IIdentificationData,
        IPreapproved,
        ICustomerData,
        ICalculationData,
        IEmploymentData,
        ISisbonData
    } from "nlb-buy-go-library-v2";
import { IOrderEndComponentObject, createOrderEndComponentData } from "nlb-buy-go-library-v2";

interface IContractCreateStore {
    ProcessData: IProcessData;
    CustomerData: ICustomerData;
    EmploymentData: IEmploymentData;
    ContractData: IContractData;
    CalculationData: ICalculationData;
    PreapprovedData: IPreapproved;
    ExposureData: IExposureData;
    IdentificationData: IIdentificationData;
    SisbonData: ISisbonData;
    OrderEndData: IOrderEndComponentObject;
    AppNavButtons: IAppNavButton[];
    NavigationSteps: INavigationSteps;
};

export const usePosOrderStore = defineStore("PosOrderStore", () => {
    const AppState = ref<IContractCreateStore>({
        ProcessData: createProcessData(),
        CustomerData: createCustomerData(),
        EmploymentData: createEmploymentData(),
        ContractData: createContractData(),
        CalculationData: createCalculationData(),
        PreapprovedData: createPreapprovedData(),
        IdentificationData: createIdentificationData(),
        ExposureData: createExposureData(),
        SisbonData: createSisbonData(),
        NavigationSteps: createNavigationSteps(),
        OrderEndData: createOrderEndComponentData(),
        AppNavButtons: [],
    });

    function reset() {
        AppState.value.ProcessData = createProcessData()
        AppState.value.CustomerData = createCustomerData()
        AppState.value.EmploymentData = createEmploymentData()
        AppState.value.ContractData = createContractData()
        AppState.value.CalculationData = createCalculationData()
        AppState.value.PreapprovedData = createPreapprovedData()
        AppState.value.IdentificationData = createIdentificationData()
        AppState.value.ExposureData = createExposureData()
        AppState.value.SisbonData = createSisbonData()
        AppState.value.OrderEndData = createOrderEndComponentData()
    };

    async function EmailVerified(Message: any){
        if(Message && Message[0] && Message[0].CallbackType == "EMAIL_VERIFICATION" && Message[0].Success){
            AppState.value.CustomerData.isEmailVerified = true;
        }
    };

    const isPreapprovedValid = computed(() => {
        const appStore = useAppStore();
        
        return (
            AppState.value.PreapprovedData.isPreapproved === true
            && AppState.value.PreapprovedData.preapprovedCreditAmount >= AppState.value.ContractData.creditAmount!
            && AppState.value.PreapprovedData.preapprovedInstallmentAmount >= AppState.value.CalculationData.installmentValNoCost
            && (AppState.value.PreapprovedData.preapprovedType !== 'S1' || appStore.User.AvtoBroker === false) // hitri preapproved (S1) samo če ni avtobroker
        );
    });

    return {
        AppState,
        reset,
        isPreapprovedValid,
        EmailVerified
    };
});
